import * as React from 'react';
const SvgText = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
        <rect width={2} height={14} rx={1} transform="matrix(0 1 1 0 2 3)" fill="currentColor" />
        <rect width={2} height={14} rx={1} transform="matrix(0 1 1 0 2 8)" fill="currentColor" />
        <rect width={2} height={8.75} rx={1} transform="matrix(0 1 1 0 2 13)" fill="currentColor" />
    </svg>
);
export default SvgText;
